import { AxiosInstance } from 'axios';
import { classToPlain } from 'class-transformer'
import { BaseService, Page } from 'yellowfin-ui-lib';
import { Anagrafica, AnagraficaRequest } from '../models/anagrafica.model';
import { SelectOption } from '../models/select-option.model';

export class AnagraficaService extends BaseService {

	constructor(http: AxiosInstance) {
		super(http);
	}

	search(request: AnagraficaRequest, page: Page): Promise<Anagrafica[]> {
		return this.mapResponse(this.http.post(`web/anagrafica/search/range/${page.start}/${page.stop}`, classToPlain(request)), Anagrafica);
	}

	searchCount(request: AnagraficaRequest): Promise<any> {
		return this.mapResponse(this.http.post(`web/anagrafica/search/count`, classToPlain(request)), Anagrafica);
	}

	getAnagrafica(id: number): Promise<Anagrafica> {
		return this.mapResponse(this.http.get(`web/anagrafica/${id}`), Anagrafica);
	}

	getMenu(type: string): Promise<SelectOption[]> {
		return this.mapResponse(this.http.get(`web/anagrafica/menu/${type}`), SelectOption);
	}

	getCommissione(id: number): Promise<Anagrafica[]> {
		return this.mapResponse(this.http.get(`web/anagrafica/commissione/${id}`), Anagrafica);
	}

	getConsiglio(): Promise<Anagrafica[]> {
		return this.mapResponse(this.http.get(`web/anagrafica/consiglio`), Anagrafica);
	}

	export(request: AnagraficaRequest): Promise<Blob> {
		return this.mapResponse(this.http.post(`web/anagrafica/export`, classToPlain(request), { responseType: 'blob' }));
	}

	downloadcv(opaque: string): Promise<Blob> {
		return this.mapResponse(this.http.get(`download/x/${opaque}`, { responseType: 'blob' }));
	}
}
